import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { styles as S } from '../styles';
import { useDialog } from '../useDialog';
import { toISODate } from '../utils';
import { IconX, IconDownload } from '../icons';
const BEREICH_LABEL = {
    '1': 'Nur diese Woche',
    '2': 'Diese + nächste Woche',
    '4': 'Vier Wochen (Monat)',
};
export function PdfExportDialog({ plaetze, montag, pdfUrl, onClose }) {
    const dialogRef = useDialog(onClose);
    const [bereich, setBereich] = useState('1');
    // Standard: alle Plätze ausgewählt
    const [ausgewaehlt, setAusgewaehlt] = useState(() => new Set(plaetze.map((p) => p.id)));
    const alle = ausgewaehlt.size === plaetze.length;
    const toggle = (id) => {
        setAusgewaehlt((prev) => {
            const next = new Set(prev);
            if (next.has(id)) {
                next.delete(id);
            }
            else {
                next.add(id);
            }
            return next;
        });
    };
    const toggleAlle = () => {
        setAusgewaehlt((prev) => prev.size === plaetze.length ? new Set() : new Set(plaetze.map((p) => p.id)));
    };
    const exportUrl = () => {
        const params = new URLSearchParams();
        params.set('woche', toISODate(montag));
        params.set('wochen', bereich);
        // Nur wenn nicht alle ausgewählt sind, den Filter mitgeben
        if (!alle && ausgewaehlt.size > 0) {
            params.set('plaetze', Array.from(ausgewaehlt).join(','));
        }
        return `${pdfUrl}&${params.toString()}`;
    };
    const kannExportieren = ausgewaehlt.size > 0;
    return (_jsx("div", { style: S.overlay, onClick: onClose, children: _jsxs("div", { ref: dialogRef, role: "dialog", "aria-modal": true, "aria-label": "PDF-Export", style: S.modal, onClick: (e) => e.stopPropagation(), children: [_jsxs("div", { style: S.modalHead, children: [_jsx("h3", { style: S.modalTitel, children: "PDF-Export" }), _jsx("button", { style: S.iconBtn, onClick: onClose, "aria-label": "Schlie\u00DFen", children: _jsx(IconX, { size: 18 }) })] }), _jsxs("div", { style: S.modalBody, children: [_jsxs("div", { children: [_jsx("label", { style: S.label, children: "Zeitraum" }), _jsx("select", { style: S.input, value: bereich, onChange: (e) => setBereich(e.target.value), children: Object.keys(BEREICH_LABEL).map((k) => (_jsx("option", { value: k, children: BEREICH_LABEL[k] }, k))) })] }), _jsxs("div", { children: [_jsx("label", { style: S.label, children: "Pl\u00E4tze" }), _jsxs("div", { style: S.pdfCheckListe, children: [_jsxs("label", { style: S.pdfAlleRow, children: [_jsx("input", { type: "checkbox", checked: alle, onChange: toggleAlle }), "Alle Pl\u00E4tze"] }), plaetze.map((p) => (_jsxs("label", { style: S.pdfCheckRow, children: [_jsx("input", { type: "checkbox", checked: ausgewaehlt.has(p.id), onChange: () => toggle(p.id) }), _jsx("span", { style: { ...S.platzDot, background: p.farbe } }), p.name, _jsx("span", { style: S.platzTyp, children: p.typ })] }, p.id)))] })] })] }), _jsxs("div", { style: S.modalFoot, children: [_jsx("button", { style: S.ghostBtn, onClick: onClose, children: "Abbrechen" }), kannExportieren ? (_jsxs("a", { style: S.primaryBtn, href: exportUrl(), onClick: onClose, children: [_jsx(IconDownload, { size: 15 }), " PDF erstellen"] })) : (_jsxs("button", { style: { ...S.primaryBtn, opacity: 0.5, cursor: 'not-allowed' }, disabled: true, children: [_jsx(IconDownload, { size: 15 }), " PDF erstellen"] }))] })] }) }));
}
